/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, elapsed: NonNullable<unknown> }} Workout_After_End_EyebrowInputs */

const en_us2_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

const pt_br2_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

const es_419_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

const pt_pt2_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

const fr_fr2_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

const de_de2_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

const it_it2_workout_after_end_eyebrow = /** @type {(inputs: Workout_After_End_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.elapsed}`)
};

/**
* | output |
* | --- |
* | "{label} · {elapsed}" |
*
* @param {Workout_After_End_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_eyebrow = /** @type {((inputs: Workout_After_End_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_eyebrow(inputs)
	if (locale === "es-419") return es_419_workout_after_end_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_eyebrow(inputs)
	return en_us2_workout_after_end_eyebrow(inputs)
});
export { workout_after_end_eyebrow as "workout-after.end_eyebrow" }